import { HttpParams } from '@angular/common/http';
import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { DynamicFieldModel } from '@share';
import { DynamicTableComponent } from 'src/app/share/dynamic-table/dynamic-table.component';
import { LoadingService } from 'src/app/share/services/loading.service';
import { CategoryService } from './category.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { CommonModule } from '@angular/common';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-category',
  imports: [DynamicTableComponent, CommonModule],
  templateUrl: './category.component.html',
  styleUrl: './category.component.scss'
})
export class CategoryComponent implements OnInit {
  total = 0;
  list: any[] = [];
  schema = {
    name: "Category List",
    permissionKey: "category",
    enableDelete: true,
    enableEdit: true,
    enableAdd: true,
    size: "middle",
    pageSize: 10,
    pageIndex: 1,
    sorts: {},
    columns: [
      {
        key: "serialNo",
        title: "No",
        type: "autoGenerate",
        width: "40px",
        isStickyRight: false,
        isStickyLeft: true,

      },
      {
        key: "group_name",
        title: "Group Name",
        type: "string",
        enableSearch: true,
        searchType: "select",
        option: [] as any[],
        width: "220px",
        isStickyRight: false,
        isStickyLeft: false,

      },
      {
        key: "type",
        title: "Main Category Type",
        type: "string",
        enableSearch: true,
        searchType: "select",
        option: [
          { text: 'User Post', value: 'User Post' },
          { text: 'Biz Post', value: 'Biz Post' },
          { text: 'Admin Post', value: 'Admin Post' },
          { text: 'Item', value: 'Item' }
        ],
        width: "260px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "maincategory_name",
        title: "Main Category Name",
        type: "string",
        enableSearch: true,
        searchType: "select",
        option: [] as any[],
        width: "260px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "category_name",
        title: "Category Name",
        type: "string",
        enableSearch: true,
        searchType: "select",
        option: [] as any[],
        width: "260px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "action",
        title: "Actions",
        type: "button",
        width: "150px",
        isStickyRight: true,
        isStickyLeft: false,
        label: [{ name: "edit", type: "edit", isDanger: false, isEnable: true }, { name: "delete", type: "danger", isEnable: true }]//,{name:"delete",type:"danger"}
      }
    ]
  };

  fieldConfig: Array<DynamicFieldModel> = [
    {
      label: 'Group Name',
      name: 'group_id',
      type: 'select',
      required: true,
      placeholder: 'Group Name',
      options: [
      ],
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Group Name Required',
        },
      ],
    },
    {
      label: 'Main Category Type',
      name: 'type',
      type: 'select',
      required: true,
      placeholder: 'Select Type',
      options: [
        { text: 'User Post', value: 'User Post' },
        { text: 'Biz Post', value: 'Biz Post' },
        { text: 'Admin Post', value: 'Admin Post' },
        { text: 'Item', value: 'Item' }
      ],
      dependOn: 'group_id',
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Main Category Type Required',
        },
      ],
    },
    {
      label: 'Main Category Name',
      name: 'parent',
      type: 'select',
      required: true,
      placeholder: 'Main Category Name',
      dependOn: ['group_id', 'type'],
      optionUrl: 'categoryhierarchy/option',
      options: [
      ],
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Main Category Name Required',
        },
      ],
    },
    {
      label: 'Name',
      name: 'name',
      type: 'input',
      placeholder: '',
      required: true,
      autofocus: true,
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Name Required',
        },
      ],
    },
    {
      label: 'id',
      name: 'id',
      type: 'hidden',
      placeholder: ''
    }
  ];
  width: string;

  constructor(private readonly modalService: NzModalService, private readonly loadingService: LoadingService, private readonly service: CategoryService, private readonly cdr: ChangeDetectorRef) { }
  ngOnInit(): void {
    this.calculateWidth();

    forkJoin({
      groups: this.service.getGroupOption(),
      maincategories: this.service.getMainCategoryItems(),
      categories: this.service.getItems()
    })
      .subscribe({
        next: ({ groups, maincategories, categories }) => {
          this.schema.columns[1].option = groups?.map((y: any) => ({
            text: y.name,
            value: y.name
          }));
          // this.schema.columns[2].option = maincategories?.data.map((y: any) => ({
          //   text: y.type,
          //   value: y.type
          // }));

          this.schema.columns[3].option = maincategories?.data.map((y: any) => ({
            text: y.maincategory_name,
            value: y.maincategory_name
          }));

          this.schema.columns[4].option = categories?.data.map((y: any) => ({
            text: y.category_name,
            value: y.category_name
          }));

          this.fieldConfig[0].options = groups?.map((y: any) => ({
            text: y.name,
            value: y.id,
            level: y.level,
            type: y.type
          }));
        },
        error: err => console.error('Error loading options:', err),
        complete: () => {
          let params = new HttpParams()
            .set('page', this.schema.pageIndex.toString())
            .set('pageSize', this.schema.pageSize.toString());
          this.loadData(params);
        }
      });
  }


  @HostListener('window:resize')
  calculateWidth() {
    const offsetWidth = 300;
    this.width = `${window.innerWidth - offsetWidth}px`;
  }

  change(data: { [key: string]: any }) {
    let params = new HttpParams()
      //.set('searchValue',this.searchValue)
      .set('page', data['pageIndex'].toString())
      .set('pageSize', data['pageSize'].toString())
      .set('filterValue', JSON.stringify(data['filters']))
      .set('sort', JSON.stringify(data['sorts']));
    this.loadData(params);
  }

  loadData(param: HttpParams = null) {
    this.loadingService.toggleTableLoading();
    this.cdr.detectChanges();
    this.service.getItems(param).subscribe({
      next: x => {
        this.list = x.data;
        this.total = x.total;
      },
      error: err => { this.loadingService.toggleTableLoading(); this.cdr.detectChanges(); },
      complete: () => { this.loadingService.toggleTableLoading(); this.cdr.detectChanges(); }
    });
  }

  formEvent(data: any) {
    if (data.id) {
      this.service.updateItem(data).subscribe(x => {
        let params = new HttpParams()
          .set('page', this.schema.pageIndex.toString())
          .set('pageSize', this.schema.pageSize.toString());
        this.loadData(params);
      });
    }
    else if (data.deleted_id) {
      this.modalService.confirm({
        nzTitle: 'Are you sure want to delete?',
        nzContent: 'This action cannot be undone.',
        nzOkText: 'Yes',
        nzCancelText: 'No',
        nzOnOk: () => {
          this.service.deleteItem(data).subscribe(x => {
            let params = new HttpParams()
              .set('page', this.schema.pageIndex.toString())
              .set('pageSize', this.schema.pageSize.toString());
            this.loadData(params);
          });
        },
        nzOnCancel: () => {

        }
      });

    }
    else {
      this.service.createItem(data).subscribe(x => {
        let params = new HttpParams()
          .set('page', this.schema.pageIndex.toString())
          .set('pageSize', this.schema.pageSize.toString());
        this.loadData(params);
      });
    }
  }
}
